import type { CalculatorMode } from "../../types/tax";

interface ModeToggleProps {
  mode: CalculatorMode;
  onModeChange: (mode: CalculatorMode) => void;
}

export default function ModeToggle({ mode, onModeChange }: ModeToggleProps) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md p-4">
      <div className="flex rounded-lg bg-gray-100 dark:bg-slate-700 p-1">
        <button
          type="button"
          onClick={() => onModeChange("reverse")}
          className={`flex-1 py-2.5 px-4 rounded-md text-sm font-medium transition-all ${
            mode === "reverse"
              ? "bg-white dark:bg-slate-600 text-sa-green shadow-sm"
              : "text-gray-600 dark:text-slate-400 hover:text-charcoal dark:hover:text-slate-200"
          }`}
        >
          <span className="flex items-center justify-center gap-2">
            <span>Net → Gross</span>
            <span className="text-xs text-gray-500 dark:text-slate-500">(Reverse)</span>
          </span>
        </button>
        <button
          type="button"
          onClick={() => onModeChange("forward")}
          className={`flex-1 py-2.5 px-4 rounded-md text-sm font-medium transition-all ${
            mode === "forward"
              ? "bg-white dark:bg-slate-600 text-sa-navy shadow-sm"
              : "text-gray-600 dark:text-slate-400 hover:text-charcoal dark:hover:text-slate-200"
          }`}
        >
          <span className="flex items-center justify-center gap-2">
            <span>Gross → Net</span>
            <span className="text-xs text-gray-500 dark:text-slate-500">(Forward)</span>
          </span>
        </button>
      </div>
    </div>
  );
}
